import React, { FC } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import styles from './styles.module.sass';
import classNames from 'classnames';
import { createPortal } from 'react-dom';

type Properties = {
  isVisible: boolean;
  isOverlay?: boolean;
};

export const Loader: FC<Properties> = ({ isVisible, isOverlay = false }) => {
  return isOverlay ? (
    createPortal(
      <Backdrop className={classNames(isVisible && styles.container)} open={isVisible}>
        <CircularProgress />
      </Backdrop>,
      document.getElementById('root'),
    )
  ) : (
    <Backdrop className={classNames(isVisible && styles.container)} open={isVisible}>
      <CircularProgress />
    </Backdrop>
  );
};
